<template>
  <vs-popup :class="'asset-modal lti-preview-modal'" :title="asset.title" :active.sync="popupActive">
    <LtiContent :asset="asset"/>
  </vs-popup>
</template>

<script>
import LtiContent from "@/components/ltiContent";

export default {
  components: {LtiContent},
  props: {
    asset: {type: Object}
  },
  data() {
    return {
      popupActive: true,
      bodyOverflow: "",
    }
  },
  mounted() {
    this.bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  },
  destroyed() {
    document.body.style.overflow = this.bodyOverflow;
    window.removeEventListener("message", this.onAssetReady)
  },
  watch: {
    popupActive(next) {
      if (!next) {
        this.$emit('close');
      }
    }
  }
}
</script>
<style>
.asset-modal.lti-preview-modal {
  width: 100%;
  height: 100%;
  display: flex;
}
.asset-modal.lti-preview-modal .bg {
  background-image: linear-gradient(135deg, #2a2399, #098cf1);
}
.asset-modal.lti-preview-modal .vs-popup {
  margin: 0;
  max-height: 100%;
  padding: 0;
  width: calc(100% - 30px);
  height: calc(100% - 30px);
}

.asset-modal.lti-preview-modal.con-vs-popup .vs-popup--content {
  width: 100%;
  height: 100%;
  max-height: 100%;
  margin: 0;
  padding: 0;
}
</style>
